import { combineReducers } from 'redux';
import MapData from './MapData';
import MapLoaded from './MapLoaded';
import Map from './Map';
import Menu from './Menu';
import MapStyle from './mapStyle';
import Search from './Search';
import Filter from './Filter';
import CategoryList from './CategoryList';
import ActiveFilter from './ActiveFilter';
import MapDirection from './MapDirection';
import LocationList from './LocationList';

const reducers = combineReducers({
    mapData : MapData ,
    map: Map,
    menu :Menu,
    mapStyle : MapStyle,
    searchQuery : Search,
    visibleData : Filter,
    places : CategoryList,
    activeFilter : ActiveFilter,
    mapLoaded : MapLoaded,
    mapDirection : MapDirection,
    locationList : LocationList
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js